import { PayloadAction, createSlice } from '@reduxjs/toolkit'

import { Tradeline } from '@/types/unlock'

export const accountTypeOptions = [
  { value: 'Mortgage', label: 'Mortgage' },
  { value: 'Heloc', label: 'HELOC' },
  { value: 'Solar', label: 'Solar' },
  { value: 'CreditLine', label: 'Credit Line' },
  { value: 'Installment', label: 'Installment' },
  { value: 'Open', label: 'Open' },
  { value: 'Revolving', label: 'Revolving' },
  { value: 'Unknown', label: 'Unknown' },
]

export const propertyLoanTypeOptions = [
  { value: 'ConventionalRealEstateMortgage', label: 'Conventional Real Estate Mortgage' },
  { value: 'FHAHomeImprovement', label: 'FHA Home Improvement' },
  { value: 'FHARealEstateMortgage', label: 'FHA Real Estate Mortgage' },
  { value: 'HomeEquity', label: 'Home Equity' },
  { value: 'HomeEquityLineOfCredit', label: 'Home Equity Line Of Credit' },
  { value: 'HomeImprovement', label: 'Home Improvement' },
  { value: 'Mortgage', label: 'Mortgage' },
  { value: 'SecondMortgage', label: 'Second Mortgage' },
]

export const solarLoanTypeOptions = [
  { value: 'Solar Lease/PPA', label: 'Solar Lease/PPA' },
  { value: 'Solar Loan', label: 'Solar Loan' },
]

export const loanTypeOptions = [
  { value: 'Agriculture', label: 'Agriculture' },
  { value: 'Airplane', label: 'Airplane' },
  { value: 'ApplianceOrFurniture', label: 'Appliance Or Furniture' },
  { value: 'AttorneyFees', label: 'Attorney Fees' },
  { value: 'AutoLease', label: 'Auto Lease' },
  { value: 'AutoLoanEquityTransfer', label: 'Auto Loan Equity Transfer' },
  { value: 'Automobile', label: 'Automobile' },
  { value: 'AutoRefinance', label: 'Auto Refinance' },
  { value: 'BiMonthlyMortgageTermsInYears', label: 'Bi Monthly Mortgage Terms In Years' },
  { value: 'Boat', label: 'Boat' },
  { value: 'Business', label: 'Business' },
  { value: 'BusinessCreditCard', label: 'Business Credit Card' },
  { value: 'Camper', label: 'Camper' },
  { value: 'ChargeAccount', label: 'Charge Account' },
  { value: 'CheckCreditOrLineOfCredit', label: 'Check Credit Or Line Of Credit' },
  { value: 'ChildSupport', label: 'Child Support' },
  { value: 'Collection', label: 'Collection' },
  { value: 'CollectionAttorney', label: 'Collection Attorney' },
  { value: 'Comaker', label: 'Comaker' },
  { value: 'CombinedCreditPlan', label: 'Combined Credit Plan' },
  { value: 'CommercialCreditObligation', label: 'Commercial Credit Obligation' },
  { value: 'CommercialLineOfCredit', label: 'Commercial Line Of Credit' },
  { value: 'CommercialMortgage', label: 'Commercial Mortgage' },
  { value: 'ConditionalSalesContract', label: 'Conditional Sales Contract' },
  { value: 'ConditionalSalesContractRefinance', label: 'Conditional Sales Contract Refinance' },
  { value: 'Consolidation', label: 'Consolidation' },
  { value: 'ConstructionLoan', label: 'Construction Loan' },
  { value: 'CreditCard', label: 'Credit Card' },
  { value: 'CreditLineSecured', label: 'Credit Line Secured' },
  { value: 'DebitCard', label: 'Debit Card' },
  { value: 'DebtCounselingService', label: 'Debt Counseling Service' },
  { value: 'DeferredStudentLoan', label: 'Deferred Student Loan' },
  { value: 'DepositRelated', label: 'Deposit Related' },
  { value: 'Educational', label: 'Educational' },
  { value: 'Employment', label: 'Employment' },
  { value: 'FactoringCompanyAccount', label: 'Factoring Company Account' },
  { value: 'FamilySupport', label: 'FamilySupport' },
  { value: 'FarmersHomeAdministrationFHMA', label: 'Farmers Home Administration FHMA' },
  { value: 'FederalConsolidatedLoan', label: 'Federal Consolidated Loan' },
  { value: 'FHAComakerNotBorrower', label: 'FHA Comaker Not Borrower' },
  { value: 'FinanceStatement', label: 'Finance Statement' },
  { value: 'GovernmentBenefit', label: 'Government Benefit' },
  { value: 'GovernmentEmployeeAdvance', label: 'Government Employee Advance' },
  { value: 'GovernmentFeeForService', label: 'Government Fee For Service' },
  { value: 'GovernmentFine', label: 'Government Fine' },
  { value: 'GovernmentGrant', label: 'Government Grant' },
  { value: 'GovernmentMiscellaneousDebt', label: 'Government Miscellaneous Debt' },
  { value: 'GovernmentOverpayment', label: 'Government Overpayment' },
  { value: 'GovernmentSecuredDirectLoan', label: 'Government Secured DirectLoan' },
  { value: 'GovernmentSecuredGuaranteeLoan', label: 'Government Secured Guarantee Loan' },
  { value: 'GovernmentUnsecuredDirectLoan', label: 'Government Unsecured Direct Loan' },
  { value: 'GovernmentUnsecuredGuaranteeLoan', label: 'Government Unsecured Guarantee Loan' },
  { value: 'HouseholdGoods', label: 'Household Goods' },
  {
    value: 'HouseholdGoodsAndOtherCollateralAuto',
    label: 'Household Goods And Other Collateral Auto',
  },
  { value: 'HouseholdGoodsSecured', label: 'Household Goods Secured' },
  { value: 'InstallmentLoan', label: 'Installment Loan' },
  { value: 'InstallmentSalesContract', label: 'Installment Sales Contract' },
  { value: 'InsuranceClaims', label: 'Insurance Claims' },
  { value: 'Lease', label: 'Lease' },
  { value: 'LenderPlacedInsurance', label: 'Lender Placed Insurance' },
  { value: 'ManualMortgage', label: 'Manual Mortgage' },
  { value: 'ManufacturedHome', label: 'Manufactured Home' },
  { value: 'MedicalDebt', label: 'Medical Debt' },
  { value: 'MobileHome', label: 'Mobil Home' },
  { value: 'MobilePhone', label: 'Mobile Phone' },
  { value: 'NoteLoan', label: 'Note Loan' },
  { value: 'NoteLoanWithComaker', label: 'Note Loan With Comaker' },
  { value: 'Other', label: 'Other' },
  { value: 'PartiallySecured', label: 'Partially Secured' },
  { value: 'PersonalLoan', label: 'Personal Loan' },
  { value: 'RealEstateJuniorLiens', label: 'Real Estate Junior Liens' },
  { value: 'RealEstateLoanEquityTransfer', label: 'Real Estate Loan Equity Transfer' },
  {
    value: 'RealEstateMortgageWithoutOtherCollateral',
    label: 'Real Estate Mortgage Without Other Collateral',
  },
  { value: 'RealEstateSpecificTypeUnknown', label: 'Real Estate Specific Type Unknown' },
  { value: 'Recreational', label: 'Recreational' },
  { value: 'RecreationalVehicle', label: 'Recreational Vehicle' },
  { value: 'Refinance', label: 'Refinance' },
  { value: 'RefundAnticipationLoan', label: 'Refund Anticipation Loan' },
  { value: 'RentalAgreement', label: 'Rental Agreement' },
  { value: 'ResidentialLoan', label: 'Residential Loan' },
  { value: 'ReturnedCheck', label: 'Returned Check' },
  { value: 'RevolvingBusinessLines', label: 'Revolving Business Lines' },
  { value: 'SecuredByCosigner', label: 'Secured By Cosigner' },
  { value: 'SecuredCreditCard', label: 'Secured Credit Card' },
  { value: 'SecuredHomeImprovement', label: 'Secured Home Improvement' },
  { value: 'SemiMonthlyMortgagePayment', label: 'Semi Monthly Mortgage Payment' },
  { value: 'SinglePaymentLoan', label: 'Single Payment Loan' },
  { value: 'SpouseSupport', label: 'Spouse Support' },
  { value: 'SummaryOfAccountsWithSameStatus', label: 'Summary Of Accounts With Same Status' },
  { value: 'TimeSharedLoan', label: 'Time Shared Loan' },
  { value: 'Title1Loan', label: 'Title 1 Loan' },
  { value: 'UnknownLoanType', label: 'Unknown Loan Type' },
  { value: 'Unsecured', label: 'Unsecured' },
  { value: 'UtilityCompany', label: 'Utility Company' },
  { value: 'VeteransAdministrationLoan', label: 'Veterans Administration Loan' },
  {
    value: 'VeteransAdministrationRealEstateMortgage',
    label: 'Veterans Administration Real Estate Mortgage',
  },
]

export const creditLineLoanTypeOptions = [
  ...loanTypeOptions,
  { value: 'HomeEquity', label: 'Home Equity' },
  { value: 'HomeEquityLineOfCredit', label: 'Home Equity Line Of Credit' },
].sort((a, b) => a.label.localeCompare(b.label))

interface addTradelineModalState {
  scrollTo: string
  isModalOpen: boolean
  activeTab: string
  values: Partial<Tradeline>
  readOnlyFields: string[]
}

const initialState: addTradelineModalState = {
  scrollTo: '',
  isModalOpen: false,
  activeTab: 'accountType',
  values: {},
  readOnlyFields: [],
}

const addTradelineSlice = createSlice({
  name: 'addTradeline',
  initialState,
  reducers: {
    setScrollTo: (state, action: PayloadAction<string>) => {
      state.scrollTo = action.payload
    },
    toggleIsModalOpen: (state) => {
      state.isModalOpen = !state.isModalOpen
    },
    setActiveTab: (state, action: PayloadAction<string>) => {
      state.activeTab = action.payload
    },
    setValues: (state, action: PayloadAction<Partial<Tradeline>>) => {
      state.values = { ...state.values, ...action.payload }
    },
    setReadOnlyFields: (state, action: PayloadAction<string[]>) => {
      state.readOnlyFields = [...state.readOnlyFields, ...action.payload]
    },
    resetAddTradelineModalState: () => {
      return initialState
    },
  },
})

export const {
  setScrollTo,
  toggleIsModalOpen,
  setActiveTab,
  setValues,
  setReadOnlyFields,
  resetAddTradelineModalState,
} = addTradelineSlice.actions

export const addTradelineReducer = addTradelineSlice.reducer
